// extracted by css-extract-rspack-plugin
export default {"bui-ButtonLink":"NVumjJIcc4YzsPM1","bui-ButtonLinkContent":"eJ5wbzSvC_Y7eHDP"};